// In-memory-ONLY store for the dashboard session token in embedded mode. The API
// client reads it synchronously in its request interceptor and sends it as the Bearer
// credential (EMBEDDED_SSO.md §4 — in-memory Bearer, never a cross-site cookie).
//
// Deliberately NOT persisted (no sessionStorage). Each page load starts with no token,
// so the parent postMessage handshake re-runs and the CURRENT parent identity is
// authoritative. Persisting it would make a reload reuse a stale session token and keep
// showing the PREVIOUS participant until it expired — wrong when the parent's identity
// changes, and it made the random-participant test always show the first one.
import { EMBEDDED_ENABLED } from './embeddedConfig';

let inMemoryToken = null;

/** Store the freshly minted session token (in memory, for this page load only). */
export function setEmbeddedToken(token) {
  inMemoryToken = token || null;
}

/** Synchronous read for the axios interceptor. Null unless embedded mode is on. */
export function getEmbeddedTokenSync() {
  if (!EMBEDDED_ENABLED) return null;
  return inMemoryToken;
}

/** Drop the session token (logout, or a failed/expired session before re-handshake). */
export function clearEmbeddedToken() {
  inMemoryToken = null;
}
